import { render, staticRenderFns } from "./PlusPricing.vue?vue&type=template&id=664f686d&scoped=true"
import script from "./PlusPricing.vue?vue&type=script&lang=js"
export * from "./PlusPricing.vue?vue&type=script&lang=js"
import style0 from "./PlusPricing.vue?vue&type=style&index=0&id=664f686d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f686d",
  null
  
)

export default component.exports